// The auth layout can finish navigating while a form awaits signup/referral
// cleanup. Replacing the same route again remounts the web app and its startup
// effects. Checkout returns still win when they request a different URL.
export function replaceAfterWebSignIn(router, destination) {
  if (typeof window !== 'undefined'
    && window.location.pathname + window.location.search === destination) return;
  router.replace(destination);
}
